import PersonaliseExperience from "../../components/PersonaliseExperience";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import { useSelector } from "react-redux";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { toast } from "react-toastify";

const SportsExperience = () => {
    const [selectedSport , setSelectedSport] = useState("Tennis");
    const [skillSelections , setSkillSelections] = useState({});
    const navigate = useNavigate();
    const { accessToken } = useSelector((state) => state?.loginInfo.accessToken);

    const sports = ["Tennis", "Pickleball"];

    const sportIds = {
        "Tennis": 1,
        "Pickleball": 2
    };

    const skillLevels = {
        Tennis: ["Beginner", "Intermediate", "Upper-Intermediate", "Proficient", "College Player", "League Player"],
        Pickleball: ["Proficient", "League Player", "Young Player", "College Player", "Pro"]
    };

    const handleSportSelection = (sport) => {
        setSelectedSport(sport);
    };

    const handleSkillChange = (skill) => {
        setSkillSelections((prev) => ({
            ...prev,
            [selectedSport]: skill
        }));
    };

    const apiData = Object.entries(skillSelections).map(([sportName, skillLevel]) => ({
        sportId: sportIds[sportName],
        skillLevel: skillLevel?.toUpperCase().replace(/\s+/g, "_")
    }));    
    
    const onNavigateButton = async () => {
        const hasSelectedSkill  = sports.some(sport => skillSelections[sport.key] != null);
        if (hasSelectedSkill ) {
            toast.error("Please select skill level for all sports.");
            return;
        }
        try {
            const result = await apiHandler({
                url: endpoint?.CREATE_TENNIS_PROFILE,
                method: 'POST',
                data: apiData,
                authToken: accessToken,
            });

            if (result?.data) {
                toast.success("Profile created successfully!");
                navigate('/subscription');
            } else {
                toast.error("Failed to create profile. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while creating the profile. Please try again.");
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh'}}>
            <PersonaliseExperience
                title={'Personalise your experience'}
                subtitle={"Choose your sport and level."}
                style={{ width: '100%' }}
                data={
                    <>
                        {/* Sports Selection */}
                        <div className="mb-3">
                            {sports.map((sport, index) => (
                                <div key={index} className="mb-4">
                                    <div
                                        className={`p-3 rounded border ${selectedSport === sport ? "bg-light border-primary" : "border-secondary"}`}
                                        onClick={() => handleSportSelection(sport)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <strong>{sport}</strong>
                                        {selectedSport === sport && (
                                            <span className="text-primary ms-2">&#10003;</span>
                                        )}
                                        {skillSelections[sport] && (
                                            <div className="mt-2 text-muted" style={{ fontSize: '14px' }}>
                                                <strong>Skill:</strong> {skillSelections[sport]}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Skill Level Dropdown only for selected sport */}
                        <div className="mb-4">
                            <label className="form-label">
                                Choose your skill level for {selectedSport}
                            </label>
                            <select
                                className="form-select"
                                value={skillSelections[selectedSport] || ""}
                                onChange={(e) => handleSkillChange(e.target.value)}
                            >
                                <option value="">Select skill level</option>
                                {skillLevels[selectedSport]?.map((level, i) => (
                                    <option key={i} value={level}>{level}</option>
                                ))}
                            </select>
                        </div>

                        {/* Next Button */}
                        <div className="pt-3" onClick={onNavigateButton}>
                            <CustomButton
                                buttonText={'Next'}
                                className='border'
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    borderRadius: '12px',
                                    background: '#006FFD',
                                    color: '#FFFFFF'
                                }}
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default SportsExperience;
